import form from './form.js';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('payment-methods', index);
Router.get('payment-methods/new', form);
Router.get('payment-methods/([a-zA-Z]+)', form);
